<template>
    <b-card class="card-objective card-objective__chart " no-body>
      <b-button :to="parent + '/sub/' + link">
      <div class="left">
        <div class="header">
          <h5>
            <PuSkeleton :loading="isLoading" :count="1" width='100px'>                
              {{title}}
            </PuSkeleton>            
          </h5>
          <PuSkeleton :loading="isLoading" :count="1" width='20px'>
            <div class="allnumber">{{allNumber}}</div>
          </PuSkeleton>
        </div>

        <PuSkeleton :loading="isLoading" :count="1">
          <div class="title mb-2">
            <h4>{{resultOne}}</h4>
            <div class="result"  :class="{negative : isNegative, done : isDone}">
              {{differences}}
            </div>          
          </div>
        </PuSkeleton>

        <PuSkeleton :loading="isLoading" :count="1" height="40px">
            <div class="line">
              <b-progress height="1.75rem" :value="value" :max="max" class="positive" :class="{negative : isNegative, done : isDone}">
              </b-progress>

              <div class="date" :class="{black : isNegative}">
                {{date}}
              </div>

              <div class="pourcentYear" :style="{left: pourcentYear + '%'}" v-if="!isDone"></div>
            </div>
        </PuSkeleton>
      </div>

        <div class="right desktop"  :class="{isLoading : isLoading}">
          <PuSkeleton :loading="isLoading" width='140px' height="95%">
              <line-chart :chartdata="chart"/>
          </PuSkeleton>
        </div>
      </b-button>
    </b-card>
</template>


<script>
import card from '../card/Card'
import lineChart from '../chart/Line'
//
export default {
  name: "cardObjectiveChart",
  components:{ 
    lineChart
  },
  mixins: [card],
  props:{
    parent:{
      type:String,
      default:'Epargne'
    },
    link:{
      type:String,
      default:'Epargne'
    },
    title:{
      type:String,
      default:'Epargne'
    },
    allNumber:{
      type:String,
      default:'125 000'
    },
    resultOne:{
      type:String,
      default:'56 000'
      },
    differences:{
      type:String,
      default:'+5 000'
      },
    date:{
      type:String,
      default:'20 mars 2020'
    },
    chart:{
      type:Object
    },  
    isNegative:{
      type:Boolean
    }, 
    isDone:{
      type:Boolean
    }  
  },
  data(){
    return {
        isLoading:true,
    }
  },
  methods : {
  },  
  mounted (){
    this.getPourcent(this.resultOne);
    this.getPourcentByYear();
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>